import React, { useState, useEffect } from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Paper,
  MenuList,
  Grow,
  ClickAwayListener,
  Popper
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FolderIcon from '@mui/icons-material/Folder';
import InfoIcon from '@mui/icons-material/Info';
import { useTranslation } from 'react-i18next';

interface ContextMenuProps {
  open: boolean;
  onClose: () => void;
  anchorPosition: { top: number; left: number } | null;
  onEdit: () => void;
  onDelete: () => void;
  onInfo?: () => void;
  itemName: string;
}

const ContextMenu: React.FC<ContextMenuProps> = ({
  open,
  onClose,
  anchorPosition,
  onEdit,
  onDelete,
  onInfo,
  itemName
}) => {
  const { i18n } = useTranslation();
  const isTr = i18n.language.startsWith('tr');
  const tt = (trText: string, enText: string) => (isTr ? trText : enText);
  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition ? anchorPosition : undefined}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        elevation: 8,
        sx: {
          minWidth: 180,
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          '& .MuiMenuItem-root': {
            borderRadius: 1,
            margin: '2px 4px',
            '&:hover': {
              backgroundColor: 'action.hover',
            },
          },
        }
      }}
      disableRestoreFocus
    >
      <MenuItem disabled sx={{ fontWeight: 'bold', opacity: 1, color: 'primary.main' }}>
        <ListItemIcon>
          <FolderIcon color="primary" />
        </ListItemIcon>
        <ListItemText 
          primary={itemName} 
          primaryTypographyProps={{ 
            variant: 'subtitle2', 
            noWrap: true,
            sx: { maxWidth: 120 }
          }} 
        />
      </MenuItem>
      
      <Divider sx={{ my: 1 }} />
      
      <MenuItem onClick={onEdit}>
        <ListItemIcon>
          <EditIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={tt('Düzenle', 'Edit')} />
      </MenuItem>
      
      {onInfo && (
        <MenuItem onClick={onInfo}>
          <ListItemIcon>
            <InfoIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={tt('Bilgiler', 'Info')} />
        </MenuItem>
      )}
      
      <Divider sx={{ my: 1 }} />
      
      <MenuItem 
        onClick={onDelete}
        sx={{ 
          color: 'error.main',
          '&:hover': {
            backgroundColor: 'error.light',
            color: 'error.contrastText',
          }
        }}
      >
        <ListItemIcon>
          <DeleteIcon fontSize="small" color="error" />
        </ListItemIcon>
        <ListItemText primary={tt('Sil', 'Delete')} />
      </MenuItem>
    </Menu>
  );
};

export default ContextMenu; 